unit ContractPriceSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.DBCtrls, Vcl.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmContractPriceSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    btnSave: TButton;
    WebButton2: TButton;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBDateTimePicker1: TDBDateTimePicker;
    wcContractPrices: TXDataWebClient;
    wdsContractPrices: TXDataWebDataSet;
    wdsContractPricesAUTONO: TIntegerField;
    wdsContractPricesCONTRACTNO: TIntegerField;
    wdsContractPricesCOSTPRICE: TFloatField;
    wdsContractPricesSUBPRICE: TFloatField;
    wdsContractPricesDEDPRICE: TFloatField;
    wdsContractPricesSPEPRICE: TFloatField;
    wdsContractPricesCONFIREMED: TStringField;
    wdsContractPricesPRICELOADBY: TStringField;
    wdsContractPricesPRICECONFIRMBY: TStringField;
    wdsContractPriceskmsprice: TFloatField;
    wdsContractPricestollprice: TFloatField;
    dsContractPrices: TDataSource;
    wdsContractPricesSTARTDATE: TDateField;
    wdsContractPricesPRICECONFIRMDATE: TDateField;
    wdsContractPricesPRICELOADDATE: TDateField;
    wdsContractPricesENDDATE: TDateField;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
    iAutoNo, iPriceSetupContractNo : Integer;
    iPriceSetupState : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmContractPriceSetup: TfrmContractPriceSetup;

implementation

{$R *.dfm}
uses
  share.common, share.classes, stfmssystem.connection;

procedure TfrmContractPriceSetup.btnSaveClick(Sender: TObject);
  procedure OnError(Error: TXDataClientError);
    begin
      btnSave.Enabled := true;
      ShowMessage(Error.ErrorMessage);
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Contract price saved successfully');
      btnSave.Enabled := true;
      Close;
    end;
begin
  btnSave.Enabled := false;
  Case iPriceSetupState of
  1:  Begin
        wdsContractPrices.FieldByName('CONTRACTNO').AsInteger := iPriceSetupContractNo;
        wdsContractPrices.FieldByName('PRICELOADDATE').AsDateTime := Date;
        wcContractPrices.RawInvoke('IstfmsloadsService.Put_ContractPriceList_Insert',[GetJsonFromDataSet(wdsContractPrices)],@OnSuccess,@OnError);
      End;
  2:  Begin
        wcContractPrices.RawInvoke('IstfmsloadsService.Put_ContractPriceList_Edit',[GetJsonFromDataSet(wdsContractPrices)],@OnSuccess,@OnError);
      End;
  End;
end;

procedure TfrmContractPriceSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmContractPriceSetup.WebFormShow(Sender: TObject);
var
  sJsonParams : String;
  PriceListParams : TPriceListParams;

   procedure OnError(Error: TXDataClientError);
    begin
       ShowMessage(Error.ErrorMessage);
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsContractPrices.Close;
      wdsContractPrices.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsContractPrices.Open;

      console.log(GetJsonFromDataSet(wdsContractPrices));
    end;
begin

  case iPriceSetupState of
    1:  Begin
          wdsContractPrices.Open;
          wdsContractPrices.Insert;
        End;

    2:  Begin

          PriceListParams := TPriceListParams.Create;
          PriceListParams.ContractNo := -1;
          PriceListParams.AutoNo := iAutoNo;

          sJsonParams := ConvertObjToJson(PriceListParams).ToJSON;

          console.log(sJsonParams);

          wcContractPrices.RawInvoke('IstfmsloadsService.Get_ContractPriceList_View',[sJsonParams],@OnSuccess,@OnError);
        End;
  end;
end;

procedure TfrmContractPriceSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnSave := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  wcContractPrices := TXDataWebClient.Create(Self);
  wdsContractPrices := TXDataWebDataSet.Create(Self);
  wdsContractPricesAUTONO := TIntegerField.Create(Self);
  wdsContractPricesCONTRACTNO := TIntegerField.Create(Self);
  wdsContractPricesCOSTPRICE := TFloatField.Create(Self);
  wdsContractPricesSUBPRICE := TFloatField.Create(Self);
  wdsContractPricesDEDPRICE := TFloatField.Create(Self);
  wdsContractPricesSPEPRICE := TFloatField.Create(Self);
  wdsContractPricesCONFIREMED := TStringField.Create(Self);
  wdsContractPricesPRICELOADBY := TStringField.Create(Self);
  wdsContractPricesPRICECONFIRMBY := TStringField.Create(Self);
  wdsContractPriceskmsprice := TFloatField.Create(Self);
  wdsContractPricestollprice := TFloatField.Create(Self);
  wdsContractPricesSTARTDATE := TDateField.Create(Self);
  wdsContractPricesPRICECONFIRMDATE := TDateField.Create(Self);
  wdsContractPricesPRICELOADDATE := TDateField.Create(Self);
  wdsContractPricesENDDATE := TDateField.Create(Self);
  dsContractPrices := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  wcContractPrices.BeforeLoadDFMValues;
  wdsContractPrices.BeforeLoadDFMValues;
  wdsContractPricesAUTONO.BeforeLoadDFMValues;
  wdsContractPricesCONTRACTNO.BeforeLoadDFMValues;
  wdsContractPricesCOSTPRICE.BeforeLoadDFMValues;
  wdsContractPricesSUBPRICE.BeforeLoadDFMValues;
  wdsContractPricesDEDPRICE.BeforeLoadDFMValues;
  wdsContractPricesSPEPRICE.BeforeLoadDFMValues;
  wdsContractPricesCONFIREMED.BeforeLoadDFMValues;
  wdsContractPricesPRICELOADBY.BeforeLoadDFMValues;
  wdsContractPricesPRICECONFIRMBY.BeforeLoadDFMValues;
  wdsContractPriceskmsprice.BeforeLoadDFMValues;
  wdsContractPricestollprice.BeforeLoadDFMValues;
  wdsContractPricesSTARTDATE.BeforeLoadDFMValues;
  wdsContractPricesPRICECONFIRMDATE.BeforeLoadDFMValues;
  wdsContractPricesPRICELOADDATE.BeforeLoadDFMValues;
  wdsContractPricesENDDATE.BeforeLoadDFMValues;
  dsContractPrices.BeforeLoadDFMValues;
  try
    Name := 'frmContractPriceSetup';
    Width := 543;
    Height := 392;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 543;
    WebPanel1.Height := 392;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 40;
    WebLabel1.Top := 171;
    WebLabel1.Width := 114;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Sub-Contractor Price:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 320;
    WebLabel2.Top := 171;
    WebLabel2.Width := 85;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Dedicated Price:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 320;
    WebLabel3.Top := 83;
    WebLabel3.Width := 56;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Cost Price:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 40;
    WebLabel4.Top := 251;
    WebLabel4.Width := 69;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Special Price:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 40;
    WebLabel5.Top := 83;
    WebLabel5.Width := 54;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Start Date:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 543;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Contract Price Setup';
    WebPanel2.ChildOrder := 5;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 332;
    WebPanel3.Width := 543;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    btnSave.SetParentComponent(WebPanel3);
    btnSave.Name := 'btnSave';
    btnSave.Left := 16;
    btnSave.Top := 16;
    btnSave.Width := 96;
    btnSave.Height := 25;
    btnSave.Caption := 'Save';
    btnSave.Color := clGreenyellow;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 129;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 40;
    WebDBEdit1.Top := 272;
    WebDBEdit1.Width := 185;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'SPEPRICE';
    WebDBEdit1.DataSource := dsContractPrices;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 320;
    WebDBEdit2.Top := 104;
    WebDBEdit2.Width := 185;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 3;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'COSTPRICE';
    WebDBEdit2.DataSource := dsContractPrices;
    WebDBEdit3.SetParentComponent(WebPanel1);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 320;
    WebDBEdit3.Top := 192;
    WebDBEdit3.Width := 185;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 4;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'DEDPRICE';
    WebDBEdit3.DataSource := dsContractPrices;
    WebDBEdit4.SetParentComponent(WebPanel1);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 40;
    WebDBEdit4.Top := 192;
    WebDBEdit4.Width := 185;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 5;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'SUBPRICE';
    WebDBEdit4.DataSource := dsContractPrices;
    WebDBDateTimePicker1.SetParentComponent(WebPanel1);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 40;
    WebDBDateTimePicker1.Top := 104;
    WebDBDateTimePicker1.Width := 185;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 6;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45944.437833217590000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker1.DataField := 'STARTDATE';
    WebDBDateTimePicker1.DataSource := dsContractPrices;
    wcContractPrices.SetParentComponent(Self);
    wcContractPrices.Name := 'wcContractPrices';
    wcContractPrices.Connection := dmData.dbConnect;
    wcContractPrices.Left := 19;
    wcContractPrices.Top := 16;
    wdsContractPrices.SetParentComponent(Self);
    wdsContractPrices.Name := 'wdsContractPrices';
    wdsContractPrices.Connection := dmData.dbConnect;
    wdsContractPrices.Left := 83;
    wdsContractPrices.Top := 16;
    wdsContractPricesAUTONO.SetParentComponent(wdsContractPrices);
    wdsContractPricesAUTONO.Name := 'wdsContractPricesAUTONO';
    wdsContractPricesAUTONO.FieldName := 'AUTONO';
    wdsContractPricesCONTRACTNO.SetParentComponent(wdsContractPrices);
    wdsContractPricesCONTRACTNO.Name := 'wdsContractPricesCONTRACTNO';
    wdsContractPricesCONTRACTNO.FieldName := 'CONTRACTNO';
    wdsContractPricesCOSTPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesCOSTPRICE.Name := 'wdsContractPricesCOSTPRICE';
    wdsContractPricesCOSTPRICE.FieldName := 'COSTPRICE';
    wdsContractPricesSUBPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSUBPRICE.Name := 'wdsContractPricesSUBPRICE';
    wdsContractPricesSUBPRICE.FieldName := 'SUBPRICE';
    wdsContractPricesDEDPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesDEDPRICE.Name := 'wdsContractPricesDEDPRICE';
    wdsContractPricesDEDPRICE.FieldName := 'DEDPRICE';
    wdsContractPricesSPEPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSPEPRICE.Name := 'wdsContractPricesSPEPRICE';
    wdsContractPricesSPEPRICE.FieldName := 'SPEPRICE';
    wdsContractPricesCONFIREMED.SetParentComponent(wdsContractPrices);
    wdsContractPricesCONFIREMED.Name := 'wdsContractPricesCONFIREMED';
    wdsContractPricesCONFIREMED.FieldName := 'CONFIREMED';
    wdsContractPricesPRICELOADBY.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICELOADBY.Name := 'wdsContractPricesPRICELOADBY';
    wdsContractPricesPRICELOADBY.FieldName := 'PRICELOADBY';
    wdsContractPricesPRICECONFIRMBY.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICECONFIRMBY.Name := 'wdsContractPricesPRICECONFIRMBY';
    wdsContractPricesPRICECONFIRMBY.FieldName := 'PRICECONFIRMBY';
    wdsContractPriceskmsprice.SetParentComponent(wdsContractPrices);
    wdsContractPriceskmsprice.Name := 'wdsContractPriceskmsprice';
    wdsContractPriceskmsprice.FieldName := 'kmsprice';
    wdsContractPricestollprice.SetParentComponent(wdsContractPrices);
    wdsContractPricestollprice.Name := 'wdsContractPricestollprice';
    wdsContractPricestollprice.FieldName := 'tollprice';
    wdsContractPricesSTARTDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSTARTDATE.Name := 'wdsContractPricesSTARTDATE';
    wdsContractPricesSTARTDATE.FieldName := 'STARTDATE';
    wdsContractPricesPRICECONFIRMDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICECONFIRMDATE.Name := 'wdsContractPricesPRICECONFIRMDATE';
    wdsContractPricesPRICECONFIRMDATE.FieldName := 'PRICECONFIRMDATE';
    wdsContractPricesPRICELOADDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICELOADDATE.Name := 'wdsContractPricesPRICELOADDATE';
    wdsContractPricesPRICELOADDATE.FieldName := 'PRICELOADDATE';
    wdsContractPricesENDDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesENDDATE.Name := 'wdsContractPricesENDDATE';
    wdsContractPricesENDDATE.FieldName := 'ENDDATE';
    dsContractPrices.SetParentComponent(Self);
    dsContractPrices.Name := 'dsContractPrices';
    dsContractPrices.DataSet := wdsContractPrices;
    dsContractPrices.Left := 147;
    dsContractPrices.Top := 16;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    wcContractPrices.AfterLoadDFMValues;
    wdsContractPrices.AfterLoadDFMValues;
    wdsContractPricesAUTONO.AfterLoadDFMValues;
    wdsContractPricesCONTRACTNO.AfterLoadDFMValues;
    wdsContractPricesCOSTPRICE.AfterLoadDFMValues;
    wdsContractPricesSUBPRICE.AfterLoadDFMValues;
    wdsContractPricesDEDPRICE.AfterLoadDFMValues;
    wdsContractPricesSPEPRICE.AfterLoadDFMValues;
    wdsContractPricesCONFIREMED.AfterLoadDFMValues;
    wdsContractPricesPRICELOADBY.AfterLoadDFMValues;
    wdsContractPricesPRICECONFIRMBY.AfterLoadDFMValues;
    wdsContractPriceskmsprice.AfterLoadDFMValues;
    wdsContractPricestollprice.AfterLoadDFMValues;
    wdsContractPricesSTARTDATE.AfterLoadDFMValues;
    wdsContractPricesPRICECONFIRMDATE.AfterLoadDFMValues;
    wdsContractPricesPRICELOADDATE.AfterLoadDFMValues;
    wdsContractPricesENDDATE.AfterLoadDFMValues;
    dsContractPrices.AfterLoadDFMValues;
  end;
end;

end.